import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

export const NewsletterFormValidationSchema = yup.object({
    email: RHFUserValidationRules.emailWithNB
});

export type NewsletterFormValues = yup.InferType<
    typeof NewsletterFormValidationSchema
>;
